import { render, staticRenderFns } from "./ViewProductOrderItemLogPopUp.vue?vue&type=template&id=f00c33d0&scoped=true&"
import script from "./ViewProductOrderItemLogPopUp.vue?vue&type=script&lang=js&"
export * from "./ViewProductOrderItemLogPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ViewProductOrderItemLogPopUp.vue?vue&type=style&index=0&id=f00c33d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00c33d0",
  null
  
)

export default component.exports